import React, { useState, useRef } from 'react';
import ArticlesTable from './ArticleTable';
import EditNewsPage from './UpdateNewsPage';

const ArticlesPage = ({
  paginatedArticles,
  currentPage,
  articlesTotalPages,
  setCurrentPage,
  onAddNews
}) => {
  const [editingArticle, setEditingArticle] = useState(null);
  const [showEditPage, setShowEditPage] = useState(false);
  const editRefreshCallbackRef = useRef(null); // Changed to useRef

  const handleEditArticle = (article, refreshCallback) => {
 
    
    setEditingArticle(article);
    editRefreshCallbackRef.current = refreshCallback; // Store in ref
    setShowEditPage(true);
  };

  const handleBackFromEdit = () => {
    setShowEditPage(false);
    setEditingArticle(null);
    editRefreshCallbackRef.current = null;
  };

  const handleUpdateArticle = (updatedArticle) => {
    setShowEditPage(false);
    setEditingArticle(null);
    editRefreshCallbackRef.current = null;
  };

  if (showEditPage && editingArticle) {
    
    
    return (
      <EditNewsPage 
        article={editingArticle}
        onBack={handleBackFromEdit}
        onUpdate={handleUpdateArticle}
        onRefresh={editRefreshCallbackRef.current} // Pass the ref value
      />
    );
  }

  return (
    <div>
      <ArticlesTable
        paginatedArticles={paginatedArticles}
        currentPage={currentPage}
        articlesTotalPages={articlesTotalPages}
        setCurrentPage={setCurrentPage}
        onEditArticle={handleEditArticle}
      />
    </div>
  );
};

export default ArticlesPage;